import React from 'react';

interface CostSummaryCardsProps {
  total: number;
  dailyAverage: number;
  byProvider: { openai: number; assemblyai: number };
  callCount: { openai: number; assemblyai: number };
  isLoading: boolean;
}

function formatUSD(value: number): string {
  return `$${value.toFixed(2)}`;
}

export const CostSummaryCards: React.FC<CostSummaryCardsProps> = ({
  total,
  dailyAverage,
  byProvider,
  callCount,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-24 mb-3" />
        <div className="h-8 bg-gray-200 rounded w-20" />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Month-to-Date Spend
      </h3>
      <p className="text-3xl font-bold text-gray-900">{formatUSD(total)}</p>
      <p className="text-xs text-gray-500 mt-1">
        ~{formatUSD(dailyAverage)}/day avg
      </p>
      <div className="mt-4 space-y-2 border-t border-gray-100 pt-3">
        <div className="flex items-center justify-between text-xs">
          <span className="text-blue-600 font-medium">OpenAI</span>
          <span className="text-gray-700">
            {formatUSD(byProvider.openai)}{' '}
            <span className="text-gray-400">({callCount.openai} calls)</span>
          </span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="text-green-600 font-medium">AssemblyAI</span>
          <span className="text-gray-700">
            {formatUSD(byProvider.assemblyai)}{' '}
            <span className="text-gray-400">({callCount.assemblyai} calls)</span>
          </span>
        </div>
      </div>
    </div>
  );
};
